import { FeedTagEntity } from "@pages/Keyword/utils/types";
import { cn } from "@util/helpers";
import parse from "html-react-parser";

type DescriptionProps = {
  /** Additional class names for styling. */
  className?: string;
  /** The feed tag entity containing description details. */
  tag: FeedTagEntity;
};

/**
 * Description component to display tag information with optional logo in with highlights template.
 * Figma: https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=2096-14876&t=m7103yrVxON0jRlB-4
 */
const Description = ({
  className,
  tag,
}: DescriptionProps): React.ReactElement => {
  const displayName = tag.displayName;
  const description = tag.blurb;
  const logo = tag.logo?.original?.url;

  return (
    <div
      data-testid="template-with-highlight-description-component"
      className={className}
    >
      {displayName ? (
        <h1 className="mb-3 w-full font-playfair text-6xl font-semibold leading-none lg:text-8xl">
          {displayName.toUpperCase()}
        </h1>
      ) : null}

      {description || (logo && logo.includes("cassette")) ? (
        <div className="gap-6 lg:flex lg:items-end">
          {description ? (
            <div className="lg:w-7/12 [&_a]:font-bold [&_a]:hover:underline">
              {parse(description)}
            </div>
          ) : null}

          {logo && logo.includes("cassette") ? (
            <div
              className={cn(
                "mt-2 border-t border-gray-850 pt-2 lg:mt-0 lg:w-5/12 lg:border-none",
                { "lg:text-right": description }
              )}
            >
              <span className="font-poppins text-xs font-light">
                BROUGHT TO YOU BY
              </span>

              <img
                src={logo}
                alt=""
                width={240}
                height={120}
                className="ml-4 inline max-w-[120px]"
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default Description;
